import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { integrationsApi } from 'src/services';

// Soft delete: we don't remove the credentials row, we just flip the
// `is_active` flag to false so the backend stops using them. The record
// (and audit history) is preserved.
export type DeleteEhrCredentialsV2Payload = {
  org_uuid: string;
  ehr_system: string;
};

export type DeleteEhrCredentialsV2Response = {
  success: boolean;
  code: number;
  message?: string;
  data?: unknown;
};

export const useDeleteEhrCredentialsV2 = (
  options?: UseMutationOptions<
    DeleteEhrCredentialsV2Response,
    Error,
    DeleteEhrCredentialsV2Payload
  >
) => {
  const { mutateAsync, ...rest } = useMutation<
    DeleteEhrCredentialsV2Response,
    Error,
    DeleteEhrCredentialsV2Payload
  >({
    mutationFn: ({ org_uuid, ehr_system }) =>
      integrationsApi
        .patch<DeleteEhrCredentialsV2Response>('/v2/ehr/credentials', {
          org_uuid,
          ehr_system,
          is_active: false,
        })
        .then((res) => res.data),
    ...options,
  });

  return { deleteCredentials: mutateAsync, ...rest };
};
